import { memo } from 'react';
import type { Route } from './+types/index';

import Main from '../../components/shared/main/main';
import Footer from '../../components/shared/footer/footer';

import Hero from './components/Hero/Hero';

export const meta: Route.MetaFunction = () => [
	{
		title: 'High-Pressure Refractive Index & Density Data — Glass2Melt',
	},
	{
		name: 'description',
		content:
			'Explore and predict high-pressure refractive index and density datasets for silicate, carbonate, oxide, and halogenated materials. Filter by class, compound, and reference — visualize results, run predictions, or download data for scientific research.',
	},
	{
		name: 'keywords',
		content:
			'refractive index, density data, high-pressure data, silicate, carbonate, oxide, halogenated, property prediction, material database, scientific datasets, download data',
	},
	{
		property: 'og:title',
		content: 'High-Pressure Refractive Index & Density Data',
	},
	{
		property: 'og:description',
		content:
			'Interactive datasets and tools to explore and predict refractive index and density measurements. View plots, tables, run predictions, and export datasets for research.',
	},
	{ property: 'og:type', content: 'website' },
	{
		name: 'twitter:title',
		content: 'High-Pressure Refractive Index & Density Data',
	},
	{
		name: 'twitter:description',
		content:
			'Interactive datasets for refractive index and density: filter, visualize, predict, and download data for scientific use.',
	},
];

export const links: Route.LinksFunction = () => [
	{
		rel: 'preload',
		as: 'image',
		fetchPriority: 'high',
		href: '/predictor.svg',
	},
];

export default memo(Index);

function Index() {
	return (
		<>
			<Main>
				<Hero />
			</Main>
			<Footer />
		</>
	);
}
